module.exports = __webpack_public_path__ + "static/media/good.82bcb96a.svg";